<template>
  <div id="app">
    <nav-bar></nav-bar>
    <div class="router-view">
      <router-view />
    </div>
    <footer-bar v-if="$route.meta.keepAlive"></footer-bar>
  </div>
</template>

<script>
import NavBar from "@/components/Nav.vue";
import FooterBar from "@/components/Footer.vue";
export default {
  components: {
    NavBar,
    FooterBar
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #363636;
}

.router-view {
  margin-top: 80px;
}
@media (max-width: 992px) {
  .router-view {
    margin-top: 60px;
  }
}

@import "node_modules/bootstrap/scss/bootstrap";
</style>

<style>
.el-menu.el-menu--horizontal {
  border: none;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 80px;
  line-height: 80px;
}
.el-menu--horizontal > .el-menu-item {
  height: 80px;
  line-height: 80px;
}
</style>
